// extracted by mini-css-extract-plugin
module.exports = {"item":"_025a50318d--item--cM5VI","label":"_025a50318d--label--h1kOF","selected-indicator":"_025a50318d--selected-indicator--v5tTE"};